import { useRef } from 'react';
import { FileRoutesByFullPath } from '@providers';
import { UseNavigateResult } from '@tanstack/react-router';
import { DEFAULT_PAGE, getParamName } from '../../../../common';

const SEARCH_DELAY = 300;

type UseSearchTableOptionsType = {
  navigateFn: UseNavigateResult<keyof FileRoutesByFullPath>;
  searchParams: Record<string, unknown>;
  tableId?: string;
};

type UseSetSearchValueReturnType = {
  setSearchValue: (search: string) => void;
  searchValue: string | undefined;
};

export const useTableSearch = ({
  searchParams,
  navigateFn,
  tableId,
}: UseSearchTableOptionsType): UseSetSearchValueReturnType => {
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const setSearchValue = (search: string) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      navigateFn({
        search: (currentSearch) => ({
          ...currentSearch,
          [getParamName('search', tableId)]:
            search.length > 0 ? search : undefined,
          [getParamName('page', tableId)]: DEFAULT_PAGE,
        }),
      });
    }, SEARCH_DELAY);
  };

  const searchValue = searchParams[getParamName('search', tableId)] as
    | string
    | undefined;

  return { setSearchValue, searchValue };
};
